import { ModelID, SearchParams, Vehicle } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'vehicle_id';
export interface VehicleSearchParams extends SearchParams<Filter, Sort>, Partial<Vehicle> {
  with_status?: boolean;
}

export const featurePath = '/v4/equipment/vehicle';

export const featureKeys = {
  all: [{ scope: 'vehicle' }] as const,

  units: (location: ModelID, search: VehicleSearchParams) =>
    [{ ...featureKeys.all[0], location, search, entity: 'units' }] as const,

  unit: (location: ModelID, id: ModelID) =>
    [{ ...featureKeys.units(location, {})[0], id, entity: 'unit' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: VehicleSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
